import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ThreadUserAvatar from "./ThreadUserAvatar";
import { messageTypes } from "../../constants/commonConstants";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import { twMerge } from "tailwind-merge";
import NotFound from "../NotFound";

const UserList = ({ users, onSelectUser, selectedUser, loading = false }) => {
  // NOTE: signed in user state
  const userState = useSelector((state) => state?.auth?.user);

  const [userList, setUserList] = useState();

  useEffect(() => {
    if (!loading) {
      setUserList(users);
    } else {
      setUserList([0, 0, 0, 0, 0]);
    }
  }, [users, loading]);

  return (
    <div className="flex-1 flex-col gap-2 md:pl-0 mb-2 lg:mb-2 scrollbar-chat overflow-x-hidden overflow-y-auto">
      {userList?.length > 0 ? (
        userList?.map((user) => (
          <div
            key={user?._id}
            onClick={!loading ? () => onSelectUser(user) : () => {}}
            className={`h-[65px] px-2 sm:px-4 flex items-center  justify-between border-l-4 cursor-pointer  ${
              selectedUser?._id === user?._id && user?._id !== undefined
                ? "bg-[#DEE1DF] border-dark"
                : "border-transparent"
            }`}
          >
            {/* left */}
            <div className=" flex items-center gap-2">
              <ThreadUserAvatar
                firstName={
                  userState?._id?.toString() !== user?.user1?._id
                    ? user?.user1?.firstName || ""
                    : user?.user2?.firstName || ""
                }
                lastName={
                  userState?._id?.toString() !== user?.user1?._id
                    ? user?.user1?.lastName || ""
                    : user?.user2?.lastName || ""
                }
                avatar={
                  userState?._id?.toString() !== user?.user1?._id
                    ? user?.user1?.profilePicture
                    : user?.user2?.profilePicture
                }
                isOnline={true}
                loading={loading}
              />

              <div className="flex flex-col ">
                <h3
                  className={
                    "font-semibold text-level-6 leading-6 max-w-[220px] line-clamp-1 text-dark m-0"
                  }
                >
                  {loading && (
                    <span className="rounded-xl text-transparent bg-slate-300 animate-pulse">
                      User Name Loading State
                    </span>
                  )}
                  {`${
                    userState?._id?.toString() !== user?.user1?._id
                      ? user?.user1?.firstName || ""
                      : user?.user2?.firstName || ""
                  } ${
                    userState?._id?.toString() !== user?.user1?._id
                      ? user?.user1?.lastName || ""
                      : user?.user2?.lastName || ""
                  }`}
                  {
                      (user?.user1 === undefined || user?.user2 === undefined) && !loading && "Unavailable User"
                  }
                </h3>
                {user?.isTyping ? (
                  <span className=" font-inter font-medium text-dark text-level-7 leading-[21px] m-0">
                    {/* Typing... */}
                  </span>
                ) : (
                  <span
                    className={twMerge(
                      loading
                        ? "font-inter text-[12px] sm:text-level-7 font-light leading-[17px] text-transparent bg-slate-300 rounded-xl animate-pulse"
                        : "font-inter text-[12px] sm:text-level-7 font-light leading-[21px] text-[#9D9D9D] max-w-[180px] line-clamp-1"
                    )}
                  >
                    {loading && "Loading State Last Message skeleton"}
                    {(user?.lastMessage?.messageTye === "TEXT" ||
                      user?.lastMessage?.messageTye ===
                        messageTypes.OFFER_ACTION) &&
                      user?.lastMessage?.content}
                    {user?.lastMessage?.messageTye === "TEXT" &&
                      user?.lastMessage?.content?.length < 1 &&
                      user?.lastMessage?.attachments?.length > 0 &&
                      "Attachment"}
                    {user?.lastMessage?.messageTye === messageTypes.OFFER &&
                      "Offer"}
                    {/* {user?._id} */}
                  </span>
                )}
              </div>
            </div>
            {/* right */}
            <div className="flex flex-col items-end m-0 leading-8">
              <span className="text-level-7 font-inter text-[#343434] whitespace-nowrap overflow-hidden text-ellipsis">
                {!loading && formatYYYY_MM_DD(user?.lastMessage?.createdAt || null)}
              </span>
              {user?.lastRead?.filter(
                (it) => it?.userId?.toString() === userState?._id?.toString()
              )[0]?.unreadCount > 0 && (
                <p
                  className={`text-[8px] font-inter font-semibold ${
                    user?.unreadCount === 0 ? 0 : "bg-dark"
                  }  flex items-center justify-center rounded-[4px] w-[14px] h-[16px] text-[#E5EAFF]`}
                >
                  {/* {user.unreadCount === 0 ? 0 : user.unreadCount} */}
                  {
                    user?.lastRead?.filter(
                      (it) =>
                        it?.userId?.toString() === userState?._id?.toString()
                    )[0]?.unreadCount
                  }
                </p>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="flex justify-center items-center h-[100%] w-full">
          <NotFound message="No Threads Found" />
        </div>
      )}
    </div>
  );
};

export default UserList;
